import SkeletonLoader from './SkeletonLoader';
import { useBootPlaceholder } from '../utils/initialLoader';

// Suspense/loading placeholder for the boot path. Identical output to SkeletonLoader;
// the only difference is that it holds the initial preview until it unmounts.
const BootLoader = () => {
  useBootPlaceholder();
  return <SkeletonLoader />;
};

export default BootLoader;
